var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import classnames from 'classnames';
import InputKeyBoard from '../input-key-board';
function normalizeValue(value, maxLength) {
    // 过滤特殊符号
    let val = !value ? '' : (value + '').replace(/\D/, '');
    if (val && val.length > maxLength) {
        val = val.slice(0, maxLength);
    }
    return val;
}
export default class InputVerifyCode extends Component {
    constructor(props) {
        super(props);
        this.itemList = null;
        this.doBlur = (ev) => {
            if (this.itemList.includes(ev.target)) {
                this.focus();
            }
            else {
                this.handleBlur();
            }
        };
        this.popInputRef = (el) => {
            const { autoFocus, inputRef } = this.props;
            this.myRef = el;
            if (inputRef) {
                inputRef(el);
            }
            if (autoFocus) {
                this.focus();
            }
        };
        this.focus = () => {
            if (this.myRef) {
                this.myRef.focus();
            }
        };
        this.blur = () => {
            if (this.myRef && this.myRef.blur) {
                this.myRef.blur();
            }
            else if (this.myRef && this.myRef.doBlur) {
                this.myRef.doBlur();
            }
        };
        this.handleChange = (eventVal) => {
            const val = typeof eventVal === 'string' ? normalizeValue(eventVal, this.maxLength) : normalizeValue(eventVal.target.value, this.maxLength);
            if (val !== this.state.value) {
                this.setState({
                    value: val,
                });
                this.props.onChange && this.props.onChange(val);
            }
        };
        this.handleBlur = () => {
            this.setState({
                focusing: false,
            }, () => {
                this.props.onBlur && this.props.onBlur(this.state.value);
                if (this.myRef.onInputBlur) {
                    this.myRef.onInputBlur(this.state.value);
                }
            });
        };
        this.onInputFocus = () => {
            this.setState({
                focusing: true,
            }, () => {
                this.props.onFocus && this.props.onFocus(this.state.value);
            });
        };
        this.onClickPanel = () => {
            setTimeout(() => {
                this.focus();
            }, 100);
        };
        this.getShowVal = () => {
            const value = this.state.value;
            const emptyLen = this.maxLength - value.length;
            let arr = [];
            for (let i = 0; i < emptyLen; i++) {
                arr[i] = '';
            }
            return value.split('').concat(arr);
        };
        this.myRef = null;
        this.maxLength = props.maxLength > 0 ? Math.ceil(props.maxLength) : 1;
        this.state = {
            value: normalizeValue(props.value || props.defaultValue, this.maxLength),
            focusing: false,
        };
    }
    static getDerivedStateFromProps(nextProps) {
        if (nextProps.value !== undefined) {
            return {
                value: normalizeValue(nextProps.value, nextProps.maxLength),
            };
        }
        return null;
    }
    render() {
        const showVal = this.getShowVal();
        const value = this.state.value;
        const _a = this.props, { errorMsg, type, maxLength, pattern, disabled, className, onBlur, customKeyBoard, onVirtualKeyboardConfirm, keyboardHeader, autoFocus } = _a, restProps = __rest(_a, ["errorMsg", "type", "maxLength", "pattern", "disabled", "className", "onBlur", "customKeyBoard", "onVirtualKeyboardConfirm", "keyboardHeader", "autoFocus"]);
        const { focusing } = this.state;
        const cls = classnames('cfm_verify_code', { 'cfm_verify_error': !!errorMsg }, className);
        this.itemList = [];
        return (<div className={cls}>
        {customKeyBoard
            ? <InputKeyBoard ref={this.popInputRef} className='cfm_verify_input' value={value} type={type} maxLength={maxLength} onChange={this.handleChange} onBlur={this.handleBlur} onFocus={this.onInputFocus} onVirtualKeyboardConfirm={onVirtualKeyboardConfirm} disabled={disabled} keyboardHeader={keyboardHeader} disableAutoHidden autoFocus={autoFocus}/>
            : <input className='cfm_verify_input' disabled={!!disabled} {...restProps} ref={this.popInputRef} type={type} pattern={pattern} value={value} defaultValue={undefined} maxLength={this.maxLength} onChange={this.handleChange} onBlur={this.handleBlur} onFocus={this.onInputFocus}/>}
        <div className='cfm_verify_panel' onClick={this.onClickPanel}>
          {showVal.map((item, index) => {
            const isCursor = focusing && (value.length === index || (value.length === this.maxLength && index === this.maxLength - 1));
            const itemCls = classnames('cfm_verify_panel_item', {
                'cfm_verify_cursor': isCursor,
                'cfm_verify_focus': isCursor || (focusing && value.length > index),
            });
            return (<div className={itemCls} ref={(el) => this.itemList.push(el)} key={index}>
                  {item}
                </div>);
        })}
        </div>
        {errorMsg ? <div className='cfm_input_code_error_tips'>{errorMsg}</div> : null}
      </div>);
    }
}
InputVerifyCode.defaultProps = {
    defaultValue: '',
    errorMsg: '',
    type: 'number',
    maxLength: 6,
    pattern: "[0-9]*",
    customKeyBoard: false,
    autoFocus: false,
};



// WEBPACK FOOTER //
// ./components/input-verify-code/index.tsx